import { useToast } from '@homebotapp/hb-react-component-catalog'
import * as Sentry from '@sentry/browser'
import { useCallback } from 'react'

import { GQLErrorHandlerOptions } from '../types/error'
import { extractGQLErrorMessage } from '../api/util/errors'

export const useGQLErrorHandler = (options: GQLErrorHandlerOptions) => {
  const { disableErrorPrompts, errorPrompts } = options

  const toast = useToast()

  return useCallback(
    (err: Error) => {
      const errMessage = extractGQLErrorMessage(err)

      const prompt = errorPrompts?.find(({ error }) => errMessage.includes(error))

      const isSentryDisabled = prompt?.skipSentry || false

      if (!isSentryDisabled) {
        Sentry.captureException(new Error(`GraphQL Error: ${errMessage}`), {
          extra: {
            error: err
          }
        })
      }

      const isPromptDisabled = prompt?.disableErrorPrompts || disableErrorPrompts

      if (isPromptDisabled) {
        return
      }

      const description = prompt?.message ?? errMessage

      toast({
        description,
        status: 'error',
        duration: 4000,
        position: 'top-right'
      })
    },
    [disableErrorPrompts, errorPrompts, toast]
  )
}
